import { useMutation } from '@tanstack/react-query'

import { pqClient } from '@/features/prequalification/localControl/endpoints/pqClient'
import type {
  ApiCreateLocalPqResourceSetResponse,
  CreateLocalPqResourceSetRequest,
} from '@/features/prequalification/localControl/types'
import type { UseMutationOptions } from '@/types/queries'

export function useCreateLocalPqResourceSetMutation(
  options?: UseMutationOptions<ApiCreateLocalPqResourceSetResponse, CreateLocalPqResourceSetRequest>,
) {
  const { mutateAsync, ...mutationResult } = useMutation({
    ...options,
    mutationFn: (request: CreateLocalPqResourceSetRequest) => pqClient.createResourceSet(request),
  })

  return { createResourceSet: mutateAsync, ...mutationResult }
}
